import { css } from '@emotion/css';

export { tableActionCell } from '@medcom/shared-ui/styles/globalCss.ts';

export const tableHoverPointer = css`
  &:hover {
    cursor: pointer;
  }
`;

export const tableLinkHoverRow = (primaryColor: string) => css`
  &:hover {
    cursor: pointer;
    color: ${primaryColor};
  }
`;

export const htmlContent = css`
  p {
    margin: 0;
    padding: 0;
  }

  p:empty::after {
    content: '\\00a0'; /* non-breaking space */
  }

  ul {
    list-style-type: disc;
  }
`;
